import React, { useState } from 'react';
import classNames from 'classnames';
import { Col, Form, Row, Accordion, FloatingLabel } from 'react-bootstrap';
import { Icon, Button, PaymentError } from 'lb-components';
import Confirm from './sms';

import classes from '../Manual.module.scss';
import { Info } from 'lb-components/src/stories/assets/icons/payment';
import { ArrowDetails } from '../../../../../../assets/icons';
import { Loader } from '../../Loader';

export default ({
  id,
  eventKey,
  platform,
  logo,
  submit,
  actionType,
  item,
  t,
  ...props
}) => {
  const [data, setData] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [cardError, setCardError] = useState();
  const [error, setError] = useState();
  const [loader, setLoader] = useState(false);

  function getProvider(eventKey) {
    switch (eventKey) {
      case 1:
        return 'emoney';
      case 3:
        return 'allpayway';
      case 2:
        return 'TbcPay';
    }
  }

  const submitHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const cardId = id !== 1 ? -1 : parseInt(e.target?.cardId.value);
    const amount = parseFloat(e.target?.amount.value);

    if (eventKey === 1) {
      if (isNaN(cardId)) {
        setCardError('ანგარიშის ნომერი არასწორია');
        return;
      }
    }
    //validate amount
    if (isNaN(amount)) {
      setError('თანხა არასწორად არის მითითებული');
      return;
    }
    const formData = {
      walletId: id,
      amount: amount,
      cardId: cardId,
      provider: getProvider(eventKey),
      confirm: confirm,
      loader: setLoader,
    };
    submit(formData, (callback) => {
      if (callback?.confirm !== undefined) {
        setConfirm(callback?.confirm);
      }
      if (callback?.cardError !== undefined) {
        setCardError(callback?.cardError);
      }
      if (callback?.error !== undefined) {
        setError(callback?.error);
      }
    });
    setData(formData);
  };
  return (
    <Accordion.Item
      eventKey={eventKey}
      className={classNames(classes.container, classes[platform])}
      {...props}
    >
      {React.createElement(
        platform === 'web'
          ? 'div'
          : actionType === 'withdraw'
          ? Accordion.Header
          : 'div',
        {
          className: classNames(classes.header, {
            [classes.deposit]: actionType === 'deposit',
          }),
        },
        <>
          <div
            className={classes.logo}
            style={{ backgroundImage: `url(${logo})` }}
          />
          <div className={classes.info} onClick={(e) => e.stopPropagation()}>
            <Icon
              Icon={Info}
              type={'vec'}
              height={'100%'}
              width={'100%'}
              style={{
                maskSize: '90%',
                WebkitMaskSize: '90%',
                backgroundColor: error ? 'var(--bs-danger)' : '#5C74A5',
              }}
            />
            <p className={classes.message}>
              {actionType === 'deposit'
                ? t('მინიმუმ, მაქსიმუმ')
                    .replace('${min}', item.limit.min)
                    .replace('${max}', item.limit.max)
                    .replace('${maxAmount}', item.limit.maxAmount)
                : t('მინიმუმ, მაქსიმუმ, საკომისიო')
                    .replace('${min}', item.limit.min)
                    .replace('${max}', item.limit.max)
                    .replace('${maxAmount}', item.limit.maxAmount)
                    .replace('${fee}', item.limit.fee)
              }
            </p>
          </div>
          {actionType === 'deposit' && (
            <div
              className={classes.providerlink}
              onClick={() =>
                submit({ type: actionType, provider: item.name, id: item.id })
              }
            >
              <Icon Icon={ArrowDetails} height={'18px'} width={'18px'} />
            </div>
          )}
        </>
      )}
      {actionType === 'withdraw' &&
        React.createElement(
          platform === 'web' ? 'div' : Accordion.Body,
          { className: classes.body },
          <>
            {confirm ? (
              <Confirm
                platform={platform}
                submit={(formData) => {
                  submit({ ...data, sms: formData.sms }, (callback) => {
                    if (callback?.sms) {
                      setError(callback.sms);
                    }
                    if (callback?.confirm !== undefined) {
                      setConfirm(callback.confirm);
                    }
                  });
                }}
              />
            ) : (
              <Row
                as={Form}
                noValidate
                autoComplete={'off'}
                onSubmit={submitHandler}
              >
                {eventKey === 1 && (
                  <Col xs={5} className={classes.amountContainer}>
                    <Form.Group className={classes.formGroup}>
                      {React.createElement(
                        platform === 'web' ? React.Fragment : FloatingLabel,
                        {
                          ...(platform === 'mob' && {
                            label: t('Emoney ანგარიშის ნომერი'),
                            style: {
                              width: '100%',
                              color: '#868895',
                            },
                            className: classes.floatingLabel,
                          }),
                        },

                        <Form.Control
                          type={'number'}
                          placeholder={t('Emoney ანგარიშის ნომერი')}
                          isInvalid={!!cardError}
                          name={'cardId'}
                          onChange={(e) => {
                            if (cardError) setCardError(null);
                            e.target.style.backgroundColor =
                              e.target.value.trim() !== '' ? '#fff' : null;
                          }}
                        />
                      )}
                      {platform === 'mob' && !!cardError && (
                        <Form.Label>{cardError}</Form.Label>
                      )}
                    </Form.Group>
                    {platform === 'web' && (
                      <PaymentError show={!!cardError} message={cardError} />
                    )}
                  </Col>
                )}
                <Col xs={4} className={classes.amountContainer}>
                  <Form.Group className={classes.formGroup}>
                    {React.createElement(
                      platform === 'web' ? React.Fragment : FloatingLabel,
                      {
                        ...(platform === 'mob' && {
                          label: t('თანხა'),
                          style: {
                            width: '100%',
                            color: '#868895',
                          },
                          className: classes.floatingLabel,
                        }),
                      },

                      <Form.Control
                        type={'number'}
                        placeholder={t('თანხა')}
                        isInvalid={error}
                        name={'amount'}
                        onChange={(e) => {
                          if (error) setError(null);
                          e.target.style.backgroundColor =
                            e.target.value.trim() !== '' ? '#fff' : null;
                        }}
                      />
                    )}
                    {platform === 'mob' && !!error && (
                      <Form.Label>{error}</Form.Label>
                    )}
                  </Form.Group>
                  {platform === 'web' && (
                    <PaymentError show={!!error} message={error} />
                  )}
                </Col>
                <Col xs={3}>
                  <Button
                    variant={'success'}
                    type={'submit'}
                    disabled={loader}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Loader loader={loader} />
                    <span>
                      {actionType === 'withdraw' ? t('გატანა') : t('შევსება')}
                    </span>
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}
    </Accordion.Item>
  );
};
